import React from 'react';
import { BubbleBadge } from '@go-client/components/BubbleUI';
import { BubbleBadgeProps } from '@go-client/components/BubbleUI/BubbleBadge';

export type VenueWarningsProps = BubbleBadgeProps & {
  text?: string;
};

export const ArchivedBadge = ({ text = 'Archived', variant }: VenueWarningsProps) => {
  return (
    <BubbleBadge variant={variant} className="p-1-i">
      {text}
    </BubbleBadge>
  );
};
